import { useState, type FormEvent } from 'react';
import { NavBar } from '../../components/NavBar';
import { SharedFooter } from '../../components/SharedFooter';

export function readInitialSessionUrl(search: string) {
  const params = new URLSearchParams(search);
  const sessionUrl = params.get('sessionUrl');
  return sessionUrl?.trim() ?? '';
}

export function buildMailtoUrl(input: {
  name: string;
  email: string;
  sessionUrl: string;
  concern: string;
}) {
  const body = [
    input.name.trim() ? `Name: ${input.name.trim()}` : null,
    input.email.trim() ? `Email: ${input.email.trim()}` : null,
    input.sessionUrl.trim() ? `Session or page: ${input.sessionUrl.trim()}` : null,
    '',
    input.concern.trim(),
  ].filter((line): line is string => line !== null).join('\n');

  return `mailto:events@lifedrawing.live?subject=${encodeURIComponent('LifeDrawing.live concern')}&body=${encodeURIComponent(body)}`;
}

export function ReportConcernPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [sessionUrl, setSessionUrl] = useState(() => readInitialSessionUrl(window.location.search));
  const [concern, setConcern] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!concern.trim()) return;

    window.location.href = buildMailtoUrl({
      name,
      email,
      sessionUrl,
      concern,
    });
  };

  return (
    <div className="min-h-screen flex flex-col bg-bg pt-[72px]">
      <NavBar variant="light" />
      <main className="flex-1 px-6 py-14">
        <section className="mx-auto w-full max-w-[680px] rounded-xl border border-line bg-panel p-6 shadow-sm">
          <p className="mb-2 text-[11px] uppercase text-text-dim">Support</p>
          <h1 className="font-display text-3xl font-light text-text">Report a concern</h1>
          <p className="mt-3 text-sm leading-relaxed text-text-dim">
            Use this for safety, privacy, payment, access, or conduct concerns. This opens an email to the LifeDrawing.live team.
          </p>

          <form onSubmit={handleSubmit} className="mt-6 grid gap-4">
            <label className="block">
              <span className="mb-1 block text-sm text-text-dim">Name</span>
              <input
                value={name}
                onChange={(event) => setName(event.target.value)}
                className="input w-full"
                autoComplete="name"
              />
            </label>
            <label className="block">
              <span className="mb-1 block text-sm text-text-dim">Email</span>
              <input
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="input w-full"
                type="email"
                autoComplete="email"
              />
            </label>
            <label className="block">
              <span className="mb-1 block text-sm text-text-dim">Session or page link</span>
              <input
                value={sessionUrl}
                onChange={(event) => setSessionUrl(event.target.value)}
                className="input w-full"
                type="url"
                placeholder="https://lifedrawing.live/s/..."
              />
            </label>
            <label className="block">
              <span className="mb-1 block text-sm text-text-dim">Concern</span>
              <textarea
                value={concern}
                onChange={(event) => setConcern(event.target.value)}
                className="input min-h-[160px] w-full resize-y"
                required
              />
            </label>
            <div className="flex justify-end">
              <button type="submit" className="btn btn-accent" disabled={!concern.trim()}>
                Open email
              </button>
            </div>
          </form>
        </section>
      </main>
      <SharedFooter />
    </div>
  );
}
